import util from '../util'

let controller = 'ParceiroLoja'
export default Object.assign({}, util.GetCrud(controller, null))
